import { daysAgo, daysAhead } from './dataset';

// Settings pages: Profile Settings, Integrations, Billing, Manage Users, Manage Roles.
// (Manage Teams, Navigation Control, Filter Composer, Saved Tags & Filters, Claim Location: settingsTwo.js)
const unixDaysAgo = n => Math.floor((Date.now() - n * 86400000) / 1000);

const billingDate = iso => iso.replace('T', ' ').slice(0, 19); // "YYYY-MM-DD HH:mm:ss"


const user = (id, name, roleName, extra) => ({
	userId: id,
	email: id,
	name,
	userImage: null,
	role: roleName === 'OWNER' ? 'OWNER' : 'CUSTOM',
	roleName,
	inviter: 'dana@brightsidecoffee.com',
	profileUserStatus: 'ACTIVE',
	currentUser: false,
	signupDate: daysAgo(400),
	lastLogin: daysAgo(1),
	inviteDate: daysAgo(401),
	reInviteCount: 0,
	profile: {
		paymentOwner: 'dana@brightsidecoffee.com'
	},
	...extra
});

const role = (role, roleId, count, access, visible, filter) => ({
	role,
	roleId,
	count,
	creatorId: 'dana@brightsidecoffee.com',
	superAdminUserId: null,
	filterId: filter ? filter.id : null,
	filterTagName: filter ? filter.name : null,
	accessFeatures: access,
	accessFeaturesVisibility: visible
});

export default {
	// Profile Settings — fallback crashes on dataStudioStatus[0].
	'/getDataStudioStatus': () => ({
		status: 200,
		dataStudioStatus: [{
			connectionStatus: 'ACTIVE',
			connectedDataStatus: {
				reviews: 'ACTIVE',
				locations: 'ACTIVE'
			}
		}]
	}),
	'/getAutomaticWeeklySyncData': () => [{
		cronString: '0 0 0 ? * MON,THU *',
		isSuperAdminCreated: false
	}],
	// 'QUEUE' / 'UPDATING' would re-poll every 5 seconds.
	'/auditDataFetchStatus': () => [{
		status: 'COMPLETED'
	}],
	'/checkAdminAccess': () => ({
		status: 200
	}),
	'/getLeftNavigationLinks': () => ({
		status: 200,
		hits: [],
		total: 0
	}),
	// Integrations
	'/getIntegrationConnections': () => ({
		google: true,
		facebook: true,
		yelp: true,
		tripadvisor: true
	}),
	// Billing — fallback crashes on addons.map. `status` here is the subscription status.
	'/getPaymentDetails': () => ({
		status: 'ACTIVE',
		billingPeriodUnit: 'month',
		billingPeriod: 1,
		planAmount: 14900,
		addons: [{
			Id: 'addon-loc-standard',
			quantity: 5,
			unit_price: 2500
		}, {
			Id: 'addon-loc-reviews',
			quantity: 5,
			unit_price: 1000
		}],
		NextBilling: billingDate(daysAhead(19)),
		endOfTerm: daysAhead(19),
		cardLastDigit: '4242',
		cardType: 'visa',
		userId: 'dana@brightsidecoffee.com',
		firstName: 'Dana',
		lastName: 'Whitfield',
		organisation: 'Brightside Coffee'
	}),
	// invoice.date is unix seconds.
	'/listInvoices': () => [{
		invoice: {
			id: 'inv_bsc_0010',
			amount_paid: 32400,
			date: unixDaysAgo(11),
			status: 'paid'
		}
	}, {
		invoice: {
			id: 'inv_bsc_0009',
			amount_paid: 32400,
			date: unixDaysAgo(41),
			status: 'paid'
		}
	}, {
		invoice: {
			id: 'inv_bsc_0008',
			amount_paid: 32400,
			date: unixDaysAgo(72),
			status: 'paid'
		}
	}, {
		invoice: {
			id: 'inv_bsc_0007',
			amount_paid: 28900,
			date: unixDaysAgo(102),
			status: 'paid'
		}
	}],
	// Manage Users — every hit needs `profile`.
	'/getUsersForProfile': () => ({
		status: 200,
		total: 5,
		hits: [user('dana@brightsidecoffee.com', 'Dana Whitfield', 'OWNER', {
			inviter: '-',
			currentUser: true,
			inviteDate: null
		}), user('marc@brightsidecoffee.com', 'Marc Oyelaran', 'Store Manager', {
			lastLogin: daysAgo(2)
		}), user('priya@brightsidecoffee.com', 'Priya Raman', 'Reviews Only', {
			lastLogin: daysAgo(3)
		}), user('tom@brightsidecoffee.com', 'Tom Beckett', 'Store Manager', {
			lastLogin: daysAgo(1),
			inviter: 'marc@brightsidecoffee.com'
		}), user('alia@brightsidecoffee.com', null, 'Agency Partner', {
			profileUserStatus: 'INVITED',
			signupDate: null,
			lastLogin: null,
			inviteDate: daysAgo(6)
		})]
	}),
	// Manage Roles / Manage Users role list — every hit with accessFeatures needs accessFeaturesVisibility.
	'/getRoles': () => ({
		status: 200,
		total: 3,
		hits: [role('Store Manager', 'role-store-manager', 2, {
			DASHBOARD: 'READ',
			REVIEWS: 'PUBLISH',
			MANAGE_LOCATIONS: 'WRITE',
			LPO: 'READ',
			SETTINGS: 'READ'
		}, {
			DASHBOARD: true,
			REVIEWS: true,
			MANAGE_LOCATIONS: true,
			LPO: true,
			SETTINGS: true
		}, {
			id: 'ft-wa-stores',
			name: 'Washington stores'
		}), role('Reviews Only', 'role-reviews-only', 1, {
			DASHBOARD: 'READ',
			REVIEWS: 'PUBLISH',
			MANAGE_LOCATIONS: 'READ',
			LPO: 'READ',
			SETTINGS: 'READ'
		}, {
			DASHBOARD: true,
			REVIEWS: true,
			MANAGE_LOCATIONS: false,
			LPO: false,
			SETTINGS: false
		}), role('Agency Partner', 'role-agency-partner', 1, {
			DASHBOARD: 'READ',
			REVIEWS: 'WRITE',
			MANAGE_LOCATIONS: 'READ',
			LPO: 'READ',
			SETTINGS: 'READ'
		}, {
			DASHBOARD: true,
			REVIEWS: true,
			MANAGE_LOCATIONS: true,
			LPO: true,
			SETTINGS: false
		}, {
			id: 'ft-all-locations',
			name: 'All locations'
		})]
	}),
	// Shared by Manage Roles, Reports, Listing Management (country/states/city) and Listing Performance.
	'/getReviewSuggestions': () => ({
		status: 200,
		country: ['US'],
		states: {
			WA: 'US',
			OR: 'US'
		},
		area: ['WA', 'OR'],
		administrativeArea: ['WA', 'OR'],
		city: ['Seattle', 'Portland', 'Tacoma', 'Bend', 'Everett'],
		locality: ['Seattle', 'Portland', 'Tacoma', 'Bend', 'Everett'],
		countryHasNoStates: false
	}),
	'/getOrganizations': () => ({
		status: 200,
		total: 3,
		hits: [{
			accountName: 'Brightside Coffee – Riverside Plaza',
			name: 'accounts/loc-riverside'
		}, {
			accountName: 'Brightside Coffee – Northgate Center',
			name: 'accounts/loc-northgate'
		}, {
			accountName: 'Brightside Coffee – Harbour Point',
			name: 'accounts/loc-harbour'
		}]
	})
};